import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["box", "check", "input"]
  }

  connect() {
    this._sync()
  }

  sync() {
    this._sync()
  }

  _sync() {
    const on = this.inputTarget.checked
    this.boxTarget.classList.toggle("tw-bg-jazzberry", on)
    this.boxTarget.classList.toggle("tw-border-jazzberry", on)
    this.boxTarget.classList.toggle("tw-bg-white", !on)
    this.boxTarget.classList.toggle("tw-border-gray-300", !on)
    this.checkTarget.classList.toggle("tw-hidden", !on)
  }
}
